import type { PassFailFieldStatus } from "@adrekic/fieldsjson"

import { FilterModifier } from "./FilterModifier"

export const PassFailEqualsFilterModifier = FilterModifier.create<PassFailFieldStatus, PassFailFieldStatus>({
	id: "pass-fail-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const PassFailNotEqualsFilterModifier = FilterModifier.create<PassFailFieldStatus, PassFailFieldStatus>({
	id: "pass-fail-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const PassFailArrayIncludesFilterModifier = FilterModifier.create<PassFailFieldStatus, PassFailFieldStatus[]>({
	id: "pass-fail-array-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const PassFailArrayExcludesFilterModifier = FilterModifier.create<PassFailFieldStatus, PassFailFieldStatus[]>({
	id: "pass-fail-array-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
